import {reactive} from 'vue';
import ChartType from '@/commons/wildcards/constants/ChartType';

export const dashboardDataGroup = reactive([
  {
    paramKey: 'dashboard_budget_plan',
    title: 'TÌNH HÌNH SỬ DỤNG DỰ TOÁN TRONG NĂM',
    loading: false,
    paramValue: {
      UnitMoney: {
        val: 1000000000,
        text: 'Tỷ đồng',
      },
      dateRange: {
        period: 500,
      },
    },
    paramPopup: 'DashboardParamBudgetPlan',
    groupData: [
      {
        id: 1,
        title: 'Tổng hợp dự toán được sử dụng trong',
        type: ChartType.Donut,
        customTitle: '',
      },
      {
        id: 2,
        title: 'Tình hình sử dụng ngân sách',
        type: ChartType.Column,
        customTitle: '',
      },
    ],
  },
  {
    paramKey: 'dashboard_receipt_expense',
    title: 'TỔNG QUAN SỐ DƯ TIỀN VÀ TÌNH HÌNH THU CHI CÁC QUỸ',
    loading: false,
    paramValue: {
      UnitMoney: {
        val: 1000000,
        text: 'Triệu đồng',
      },
      dateRange: {
        period: 500,
      },
    },
    paramPopup: 'DashboardParamReceiptExpense',
    groupData: [
      {
        id: 1,
        title: 'Số dư tiền mặt, tiền gửi',
        type: ChartType.Donut,
        customTitle: '',
      },
      {
        id: 2,
        title: 'Thu chi các quỹ tài chính ngoài ngân sách xã',
        type: ChartType.Column,
        customTitle: '',
      },
      {
        id: 3,
        title: 'Tình hình thu hộ',
        type: ChartType.Column,
        customTitle: '',
      },
      {
        id: 4,
        title: 'Tình hình chi hộ',
        type: ChartType.Column,
        customTitle: '',
      },
    ],
  },
]);
